import { withGlobal } from "components/global/GlobalWrapper";
import { InvoiceEdit } from "./InvoiceEdit";
import { residentPaymentsReducers } from 'components/stores/resident_payments/reducers'

export default withGlobal(InvoiceEdit, { reducers: residentPaymentsReducers })
